import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';

const BannerSlot = ({ slot }) => {
  const [banner, setBanner] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    loadBanner();
  }, [slot, user]);

  const loadBanner = async () => {
    try {
      const res = await api.get('/admin/banners/active', {
        params: { class_id: user?.classId }
      });
      const data = res.data.data;
      setBanner(data[slot] || null);
    } catch {
      setBanner(null);
    }
  };

  const handleClick = async () => {
    if (!banner) return;
    try {
      await api.post(`/admin/banners/${banner.id}/click`);
    } catch {}
    window.open(banner.destination_url, '_blank', 'noopener,noreferrer');
  };

  // Critical: render NOTHING if no banner
  if (!banner?.image_url) return null;

  return (
    <div
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        borderRadius: 'var(--radius)',
        overflow: 'hidden',
        border: '1px solid var(--border)'
      }}
    >
      <img
        src={banner.image_url}
        alt={banner.title}
        style={{ width: '100%', display: 'block', maxHeight: '90px', objectFit: 'cover' }}
        onError={() => setBanner(null)}
      />
    </div>
  );
};

export default BannerSlot;
